var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapBackBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 10C1.6665 7.64298 1.6665 6.46447 2.39874 5.73223C3.13097 5 4.30948 5 6.6665 5H10.8332C13.1902 5 14.3687 5 15.1009 5.73223C15.8332 6.46447 15.8332 7.64298 15.8332 10C15.8332 12.357 15.8332 13.5355 15.1009 14.2678C14.3687 15 13.1902 15 10.8332 15H6.6665C4.30948 15 3.13097 15 2.39874 14.2678C1.6665 13.5355 1.6665 12.357 1.6665 10Z",
    stroke: "#123B6D",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 7.91699L16.6895 8.05966C17.2572 8.15428 17.5411 8.20159 17.7565 8.3392C17.9684 8.47456 18.1345 8.67067 18.2332 8.9019C18.3335 9.13698 18.3335 9.42476 18.3335 10.0003C18.3335 10.5759 18.3335 10.8637 18.2332 11.0987C18.1345 11.33 17.9684 11.5261 17.7565 11.6614C17.5411 11.7991 17.2572 11.8464 16.6895 11.941L15.8335 12.0837",
    stroke: "#123B6D",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.33301V11.6663",
    stroke: "#123B6D",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.33301V11.6663",
    stroke: "#123B6D",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.33301V11.6663",
    stroke: "#123B6D",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.33301V11.6663",
    stroke: "#123B6D",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBackBattery);
export default __webpack_public_path__ + "static/media/map-back-battery.7667975af338dbf8254e321fca61775e.svg";
export { ForwardRef as ReactComponent };